import isEmail from 'is-email';

import types from '../../elements/types';

export function parseText(text) {

  const words = text.split(' ');
  const result = [];

  for (let word of words) {

    const stats = {
      text: word
    };
    let type = 'text';

    if (word === '') {
      continue;
    }

    if (isEmail(word) === true) {
      type = 'link';
      stats.url = `mailto:${word}`;
    }

    stats.type = type;

    result.push(stats);

  }

  return result;

}

export function tryGetNode(text) {

  try {

    const data = JSON.parse(text);

    if (data.type === 'node') {
      return data.data;
    }

    return null;

  } catch (exception) {
    return null;
  }

}

export function determineFontSize(node) {

  if (node.type === types.HEADING_ONE) {
    return 26;
  } else if (node.type === types.HEADING_TWO) {
    return 22;
  } else if (node.type === types.HEADING_THREE) {
    return 20;
  } else if (node.type === types.HEADING_FOUR) {
    return 18;
  } else if (node.type === types.HEADING_FIVE) {
    return 16;
  } else if (node.type === types.HEADING_SIX) {
    return 14;
  }

  return 12;

}